import { useEffect, useState } from "react";
import { api } from "../../../lib/api";
import { AttendanceCell, CELL_STYLES } from "./AttendanceCell";

const thisMonth = () => new Date().toISOString().slice(0, 7);

const LEGEND = [["present", "Present"], ["absent", "Absent"], ["leave", "Leave"], ["holiday", "Holiday"], ["weekoff", "Week off"]];

export const CalendarTab = () => {
  const [emps, setEmps] = useState([]);
  const [empId, setEmpId] = useState("");
  const [month, setMonth] = useState(thisMonth());
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/employees").then((r) => {
      const active = r.data.filter((e) => e.status === "active");
      setEmps(active);
      if (active.length && !empId) setEmpId(active[0].id);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!empId || !month) return;
    api.get(`/attendance/calendar/${empId}`, { params: { month } }).then((r) => setData(r.data)).catch(() => setData(null));
  }, [empId, month]);

  const leadingBlanks = data ? (new Date(data.days[0].date + "T00:00:00").getDay() + 6) % 7 : 0;

  return (
    <div className="space-y-4" data-testid="attendance-calendar-tab">
      <div className="flex flex-wrap gap-3">
        <select value={empId} onChange={(e) => setEmpId(e.target.value)} data-testid="calendar-employee-select"
          className="min-h-[44px] px-3 rounded-lg border border-stone-300 bg-white">
          {emps.map((e) => <option key={e.id} value={e.id}>{`${e.name} (${e.employee_code})`}</option>)}
        </select>
        <input type="month" value={month} onChange={(e) => setMonth(e.target.value)} data-testid="calendar-month-input"
          className="min-h-[44px] px-4 rounded-lg border border-stone-300 bg-white" />
      </div>

      {data && (
        <div className="bg-white border border-stone-200 rounded-lg p-4 sm:p-6 space-y-4">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <h3 className="font-heading font-bold">{data.employee_name} · {data.month}</h3>
            <div className="flex flex-wrap gap-2 text-xs" data-testid="calendar-summary">
              <span className="px-2.5 py-1 rounded-full bg-green-50 text-green-700 font-bold tabular-nums">{data.summary.present} present</span>
              <span className="px-2.5 py-1 rounded-full bg-red-50 text-red-700 font-bold tabular-nums">{data.summary.absent} absent</span>
              <span className="px-2.5 py-1 rounded-full bg-amber-50 text-amber-700 font-bold tabular-nums">{data.summary.leave} leave</span>
            </div>
          </div>

          <div className="grid grid-cols-7 gap-1.5" data-testid="attendance-calendar-grid">
            {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((d) => (
              <div key={d} className="text-center text-[11px] font-bold uppercase tracking-wide text-stone-400 py-1">{d}</div>
            ))}
            {Array.from({ length: leadingBlanks }).map((_, i) => <div key={`blank-${i}`} />)}
            {data.days.map((d) => <AttendanceCell key={d.date} day={d} />)}
          </div>

          <div className="flex flex-wrap gap-3 pt-1">
            {LEGEND.map(([k, label]) => (
              <span key={k} className="flex items-center gap-1.5 text-xs text-stone-500">
                <span className={`w-3.5 h-3.5 rounded ${CELL_STYLES[k].split(" ")[0]}`} /> {label}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
